import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';

// Local component
import { LoginComponent } from './login.component';

//Query file
import { UserQueryService } from '../../queryFiles/index';

const routes = [
    {
        path: 'login',
        component: LoginComponent,
    }
];

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        // Query file
        UserQueryService
    ],
})

export class LoginModule {

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/authentication/login/login.module.ts